import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface AuthRouteProps {
  requiredPermission?: { resource: string; type: 'can_read' | 'can_write' };
  children: ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ requiredPermission, children }) => {
  const { isAuthenticated, hasPermission, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission.resource, requiredPermission.type)) {
    // Redirect to a default page if permission is denied
    return <Navigate to="/calendar" replace />;
  }

  return <>{children}</>;
};

export default AuthRoute;

